module.exports = __webpack_public_path__ + "img/suggestion.c6eba4ba.svg";